import * as ROLES from "../Utils/Roles_Types";
import { SERVICE_URL_API } from "../Utils/Strings/URL";

function callApi(endpoint, authenticated, method = "GET", data) {
  let token = localStorage.getItem(ROLES.TOKEN_KEY) || null;
  let config = {};
  if (authenticated) {
    if (token) {
      config = {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        method: method
      };
    } else {
      config = {
        method: method
      };
      //throw "No token saved!";
    }
  }
  if (method === "POST") {
    config.body = JSON.stringify(data.data);
  }
  
  return fetch(SERVICE_URL_API + endpoint, config)
    .then(response => response.json().then(json => ({ json, response })))
    .then(({ json, response }) => {
      if (!response.ok || (response.ok && json.Code !== 200))
        return Promise.reject(json);
      return method === "DELETE" ? data : json.Data;
    })
    .catch(err => Promise.reject(err));
}

export const CALL_API = "Call API";

export default store => next => action => {
  const callAPI = action[CALL_API];

  // So the middleware doesn't get applied to every single action
  if (typeof callAPI === "undefined") {
    return next(action);
  }

  let { endpoint, types, authenticated } = callAPI;

  const [requestType, successType, errorType] = types;

  const method = callAPI.method || "GET";
  const data = callAPI || {};
  
  const actionWith = data => {
    const finalAction = Object.assign({}, action, data);
    delete finalAction[CALL_API];
    return finalAction;
  };

  next(actionWith({ type: requestType }));
  // Passing the authenticated boolean back in our data will let us distinguish between normal and secret quotes
  
  //console.log(endpoint, authenticated, method, data);
  return callApi(endpoint, authenticated, method, data).then(
    response =>
      next({
        response,
        authenticated,
        type: successType,
        params: data
      }),
    error =>
      next({
        error: error.Message || "There was an error.",
        type: errorType
      })
  );
};



// WEBPACK FOOTER //
// ./src/Middlewares/api.js